import PropTypes from 'prop-types';
import SnackbarCard from './SnackbarCard';

export default function SnackbarDefault({ message }) {
    return (
        <SnackbarCard>
            <div className="text-sm">{message}</div>
        </SnackbarCard>
    );
}

SnackbarDefault.propTypes = {
    message: PropTypes.string.isRequired,
};
